import { observer } from 'mobx-react';
import * as React from 'react';
import ModalReactions from '../../../../../../../../../Modal/ModalReactions';
import { LearningCollectionPublishResource } from '../../../Store/Types';
import ModalSwitcher from './ModalSwitcher';
import InviteParticipantStore from './Store';
import { FormTemplate } from '../../../../../../../../../../Resource/FormTemplates/Types';

interface Props {
  learningCollectionPublishResource: LearningCollectionPublishResource;
  inviteParticipantStore: InviteParticipantStore;
  template: FormTemplate;
}

const InviteParticipantModal: React.FC<Props> = ({
  inviteParticipantStore,
  learningCollectionPublishResource,
  template,
}) => (
  <>
    <ModalSwitcher
      store={inviteParticipantStore}
      learningCollectionPublishResource={learningCollectionPublishResource}
      template={template}
    />
    <ModalReactions store={inviteParticipantStore.modalStore} />
  </>
);

export default observer(InviteParticipantModal);
